/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import Accesspage from "./../../common/404";
import TatReport from "../Reports/Tat-Report";
class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
    };
  }
  componentDidMount() {
    // console.log(this.props);
  }
  renderbodyLayer() {
    const { slug } = this.props.match.params;
    const { menuList } = this.props;
    let obj = null;
    menuList.map((data) => {
      var subData = data.submenu.find((o) => o.route === slug);
      if (subData != undefined) {
        obj = subData;
      }
    });
    var page = null;
    if (obj !== undefined) {
      switch (slug) {
        // case 'tat-reports':
        case "radiology-overall-tat":
        case "billing-overall-tat":
        case "consulting-overall-tat":
        case "radiology-hourly-tat":
        case "billing-hourly-tat":
        case "consulting-hourly-tat":
          page = <TatReport {...this.props} menuList={menuList} />;
          break;
        default:
          let submenu = null;
          if (menuList[0]["submenu"].length !== 0) {
            submenu = menuList[0]["submenu"][0]["route"];
          }
          if (submenu !== null) {
            this.props.history.push(`/${menuList[0]["route"]}/${submenu}`);
          } else {
            this.props.history.push(`/${menuList[0]["route"]}`);
          }
          break;
      }
    } else {
      page = <Accesspage></Accesspage>;
    }

    return page;
  }
  render() {
    return <div>{this.renderbodyLayer()}</div>;
  }
}

export default Reports;
